import styled from "styled-components";
import { sizes } from "$/ui/styles/tokens/tokens";

export const Svg = styled.svg`
  width: ${sizes.sz016};
  height: ${sizes.sz016};
`;
